"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProtectedRoute;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
function ProtectedRoute({ component, path, exact, isProtected, redirectTo = '/', ...rest }) {
    if (isProtected) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: redirectTo });
    }
    return react_1.default.createElement(react_router_dom_1.Route, { exact: exact, path: path, component: component, ...rest });
}
